/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuI7V3%7Bjustify-content%3Aspace-between%7D%0A._0hPCNLchRC%7Balign-items%3Aflex-start%7D%0A._3SamIHPgdg%7Bmargin-block%3Avar(--ds-space-0%2C0)%7D%0A._3zvHkHdC7N%7Boverflow-wrap%3Aanywhere%7D%0A._3W2Oc8wPeg%7Bword-break%3Abreak-word%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._313842FQfX%7Bmargin-top%3Avar(--ds-space-025%2C2px)%7D");









import React from 'react';
import { useIntl } from 'react-intl';
import Heading from '@atlaskit/heading/heading';
import Link from '@atlaskit/link/link';
import { RovoIcon } from '@atlaskit/logo';
import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import type { AgentCreatorType } from '../../common/types';
import { HiddenIcon } from '../../common/ui/hidden-icon';
import { StarIconButton } from '../../common/ui/star-icon-button';
import { isForgeAgentByCreatorType } from '../../common/utils/is-forge-agent';
import { messages } from './messages';
const styles = {
  clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
  rovoIconWrapper: "_3iDTPbQ4SZ",
  name: "_37wbyuI7V3 _0hPCNLchRC",
  description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
  headingWrapper: "_1mT5xdRAKS",
  hiddenIconWrapper: "_313842FQfX"
};
type AgentCreator = {
  type: 'CUSTOMER';
  name: string;
  profileLink: string;
  status?: 'active' | 'inactive' | 'closed' | string;
} | {
  type: 'SYSTEM';
} | {
  // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
  type: 'THIRD_PARTY' | 'FORGE' | 'REMOTE_A2A';
  name: string;
} | {
  type: 'OOTB';
};
export const getAgentCreator = ({
  creatorType,
  authoringTeam,
  userCreator,
  forgeCreator
}: {
  creatorType: string;
  authoringTeam?: {
    displayName: string;
    profileLink?: string;
  };
  userCreator?: {
    name: string;
    status?: string;
    profileLink?: string;
  };
  forgeCreator?: string;
}): AgentCreator | undefined => {
  if (creatorType === 'SYSTEM') {
    return {
      type: ('SYSTEM' as const)
    };
  }
  if (fg('rovo_agent_support_a2a_avatar') ? isForgeAgentByCreatorType((creatorType as AgentCreatorType)) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
  ) {
    return {
      // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
      type: fg('jira_improve_agent_profile_for_a2a') ? (creatorType as 'THIRD_PARTY' | 'FORGE' | 'REMOTE_A2A') : ('FORGE' as const),
      name: forgeCreator ?? ''
    };
  }
  if (creatorType === 'OOTB') {
    return {
      type: ('OOTB' as const)
    };
  }
  if (creatorType === 'CUSTOMER') {
    if (authoringTeam) {
      return {
        type: ('CUSTOMER' as const),
        name: authoringTeam.displayName,
        profileLink: authoringTeam.profileLink ?? ''
      };
    }
    if (!userCreator?.profileLink) {
      return undefined;
    }
    return {
      type: ('CUSTOMER' as const),
      name: userCreator.name,
      profileLink: userCreator.profileLink,
      status: userCreator.status
    };
  }
  return;
};
export const AgentProfileCreator = ({
  creator,
  onCreatorLinkClick,
  isLoading,
  showCreatorNameWithoutLink = false
}: {
  /**
   * Get this value from `getAgentCreator`
   */
  creator?: AgentCreator;
  isLoading: boolean;
  onCreatorLinkClick: () => void;
  /**
   * Render the creator as plain text instead of a link.
   */
  showCreatorNameWithoutLink?: boolean;
}): JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  const getCreatorRender = () => {
    if (isLoading) {
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: <Skeleton testId="agent-profile-creator-skeleton" isShimmering height={18} width={100} />
      });
    }
    if (!creator) {
      return null;
    }
    if (creator.type === 'SYSTEM' || creator.type === 'OOTB') {
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: <Inline alignBlock="center" testId="atlassian-icon">
						<AtlassianIcon label="" size="small" appearance="brand" />
						<Box>Atlassian</Box>
					</Inline>
      });
    }
    if (creator.type === 'CUSTOMER') {
      const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage(messages.agentDeactivated) : ''}`;
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : <Link href={creator.profileLink} onClick={() => onCreatorLinkClick()} target="_blank">
						{creatorName}
					</Link>
      });
    }
    if (creator.type === 'REMOTE_A2A') {
      return formatMessage(messages.remoteAgentCreatedBy, {
        creatorNameWithLink: creator.name
      });
    }

    // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') {
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: creator.name
      });
    }
    return null;
  };
  const creatorRender = getCreatorRender();
  const hideCreatorIcon = expValEquals('platform_editor_agent_mentions', 'isEnabled', true) && fg('platform_editor_agent_mentions_drop_one_fixes') || fg('platform_editor_agent_card_fixes');
  if (fg('jira_improve_agent_profile_for_a2a')) {
    const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
    return creatorRender ? <Box xcss={styles.clickableItem}>
				{showRovoIcon ? <Box xcss={styles.rovoIconWrapper} testId="rovo-icon-wrapper" aria-hidden="true">
						<RovoIcon appearance="brand" size="small" />
					</Box> : null}
				{creatorRender}
			</Box> : null;
  }
  return creatorRender ? <Box xcss={styles.clickableItem}>
			{!hideCreatorIcon && <Box xcss={styles.rovoIconWrapper} testId="rovo-icon-wrapper" aria-hidden="true">
					<RovoIcon appearance="brand" size="small" />
				</Box>}
			{creatorRender}
		</Box> : null;
};
export const AgentProfileInfo = ({
  agentName,
  agentDescription,
  creatorRender,
  starCountRender,
  headingRender,
  isStarred,
  isHidden,
  onStarToggle,
  showStarButton = true,
  renderAdditionalContent
}: {
  agentName: string;
  agentDescription?: string | null;
  creatorRender: React.ReactNode;
  starCountRender: React.ReactNode;
  headingRender?: React.ReactNode;
  isStarred: boolean;
  isHidden: boolean;
  onStarToggle: () => void;
  showStarButton?: boolean;
  renderAdditionalContent?: () => React.ReactNode;
}): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  return <Stack space="space.100">
			<Inline xcss={styles.name} space="space.100" alignBlock="center">
				<Inline space="space.075" xcss={styles.headingWrapper}>
					<Heading as="h2" size="medium">
						{agentName}
					</Heading>
					{headingRender}
					{isHidden && <Box xcss={styles.hiddenIconWrapper}>
							<Tooltip content={formatMessage(messages.hiddenTooltip)} position="top">
								<HiddenIcon label={formatMessage(messages.hiddenIcon)} />
							</Tooltip>
						</Box>}
				</Inline>
				{showStarButton && <StarIconButton isStarred={isStarred} handleToggle={onStarToggle} agentName={agentName} />}
			</Inline>
			{creatorRender}
			{!!agentDescription && <Box xcss={styles.description} as="p">
					{agentDescription}
				</Box>}
			{starCountRender}
			{!!renderAdditionalContent && renderAdditionalContent()}
		</Stack>;
};